import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppSettingsProvider } from './context/AppSettingsContext';
import './utils/suppressWarnings';
import './styles/tooltip.css';
import './styles/dark-mode-override.css';
import './styles/dialog-select.css';
import './styles/ai-devquest-theme.css';
import './styles/amazon-index-checker.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsOfService from './pages/TermsOfService';
import AppHub from './components/app-hub/AppHub';
import GlossaryDashboard from './pages/glossary/Dashboard';
import GlossaryFavorites from './pages/glossary/Favorites';
import GlossarySettings from './pages/glossary/Settings';
import { GlossaryLayout } from './components/glossary/GlossaryLayout';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import Layout from './components/layout/Layout';
import { TooltipProvider } from './components/ui/tooltip';
import { OptimizationProvider } from './components/ui/optimization-progress';
import { DarkModeProvider } from './context/DarkModeContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { CategoryProvider } from './context/CategoryContext';
import { NotificationsProvider } from './context/NotificationsContext';
import CookieConsent from './components/cookie-consent/CookieConsent';
import Settings from './pages/Settings';
import IdeaMachineLayout from './components/idea-machine/IdeaMachineLayout';
import ProductsPage from './pages/ProductsPage';
import StoresPage from './pages/StoresPage';
import IdeaMachineDashboard from './pages/idea-machine/Dashboard';
import IdeaLaunchpad from './pages/idea-machine/IdeaLaunchpad';
import IdeaGalaxyPage from './pages/idea-machine/IdeaGalaxyPage';
import { IdeaFeedPage } from './pages/idea-machine/IdeaFeedPage';
import YourIdeas from './pages/idea-machine/YourIdeas';
import IdeaMachineSettings from './pages/idea-machine/Settings';
import AdminPanel from './pages/admin/AdminPanel';

import GoodThingsLayout from './components/good-things/GoodThingsLayout';
import GoodThingsDashboard from './pages/good-things/Dashboard';
import GoodThingsFeed from './pages/good-things/Feed';
import GoodThingsWeeklyDigest from './pages/good-things/WeeklyDigest';
import GoodThingsSettings from './pages/good-things/Settings';
import GoodThingsNetwork from './pages/good-things/Network';
import SOPLayout from './components/sop/SOPLayout';
import SOPDashboard from './pages/sop/Dashboard';
import SophiePage from './pages/sop/SophiePage';
import SOPFavorites from './pages/sop/Favorites';
import SOPSettings from './pages/sop/Settings';
import Favorites from './pages/good-things/Favorites';
import PromptsPage from './pages/PromptsPage';
import { CustomToaster } from "./components/ui/custom-toaster"
import { IdeogramLayout } from './components/ideogram/IdeogramLayout';
import { Gallery } from './components/ideogram/Gallery';
import { Prompts } from './components/ideogram/Prompts';
import DayAwayLayout from './components/day-away/DayAwayLayout';
import {
  DayAwayDashboard,
  DayAwayLedger,
  DayAwayDashboardSheet,
  DayAwaySettings,
} from './pages/day-away';
import MyTeam from './pages/day-away/MyTeam';
import DayAwayCalendar from './pages/day-away/Calendar';
import { TimeOffDialogProvider } from './context/TimeOffDialogContext';
import { PLMSApp } from './pages/plms/PLMSApp';
import { PLMSDashboard } from './pages/plms/Dashboard';
import { AllItems } from './pages/plms/AllItems';
import { MasterLists } from './pages/plms/MasterLists';
import PMT2Layout from './components/pmt2/PMT2Layout';
import PMT2Page from './pages/pmt2';
import { PMT3SelectionProvider } from './context/PMT3SelectionContext';
import PMT2Settings from './pages/pmt2/Settings';
import PMT3ManageCompanies from './components/pmt2/PMT3ManageCompanies';
import AIDevQuestLayout from './components/ai-devquest/AIDevQuestLayout';
import AIDevQuestDashboard from './pages/ai-devquest';
import AIDevQuestSettings from './pages/ai-devquest/Settings';
import EmployeeDirectoryLayout from './components/employee-directory/EmployeeDirectoryLayout';
import EmployeeDirectoryDashboard from './pages/employee-directory/Dashboard';
import EmployeeDirectoryDirectory from './pages/employee-directory/Directory';
import EmployeeDirectoryGlobe from './pages/employee-directory/Globe';
import ProductManagerLayout from './components/product-manager/ProductManagerLayout';
import ProductManagerDashboard from './pages/product-manager/Dashboard';
import ProductManagerProjects from './pages/product-manager/Projects';
import ProductManagerProjectDetail from './pages/product-manager/ProjectDetail';
import ProductManagerTasks from './pages/product-manager/Tasks';
import ProductManagerTaskDetail from './pages/product-manager/TaskDetail';
import ProductManagerSettings from './pages/product-manager/Settings';
import PpcFarmLayout from './components/ppc-farm/PpcFarmLayout';
import PpcFarmDashboardPage from './pages/ppc-farm/Dashboard';
import PpcFarmKeywordDiscoveryPage from './pages/ppc-farm/KeywordDiscovery';
import PpcFarmTargetLedgerPage from './pages/ppc-farm/TargetLedger';
import PpcFarmCohortLedgerPage from './pages/ppc-farm/CohortLedger';
import PpcFarmMailingLedgerPage from './pages/ppc-farm/MailingLedger';
import PpcFarmCohortBuilderPage from './pages/ppc-farm/CohortBuilder';
import PpcFarmPotentialProblemsPage from './pages/ppc-farm/PotentialProblems';
import PpcFarmReviewSessionPage from './pages/ppc-farm/ReviewSession';
import PpcFarmMailingCostDashboard from './pages/ppc-farm/MailingCostDashboard';
import PpcFarmSettings from './pages/ppc-farm/Settings';
import './styles/glossary-override.css';
import SBSearchTermReportLayout from './components/sb-search-term-report/SBSearchTermReportLayout';
import SBSearchTermReportIndex from './pages/sb-search-term-report/index';
import SBSearchTermReportDashboard from './pages/sb-search-term-report/Dashboard';
import SBSearchTermReportProfileSelection from './pages/sb-search-term-report/ProfileSelection';
import FarmingResults from './pages/farming-results';
import { FarmingResultsSelectionProvider } from './context/FarmingResultsSelectionContext';
import AmazonLink from './pages/AmazonLink';
import AmazonIndexLayout from './components/amazon-index-checker/AmazonIndexLayout';
import AmazonIndexChecker from './pages/amazon-index-checker';
import { PrimaryLedgerProvider } from './components/primary-ledger/PrimaryLedgerContext';
import PrimaryLedgerLayout from './components/primary-ledger/PrimaryLedgerLayout';
import PrimaryLedgerDashboard from './pages/primary-ledger/Dashboard';
import PrimaryLedgerSnapshots from './pages/primary-ledger/Snapshots';
import PrimaryLedgerManageCompanies from './pages/primary-ledger/ManageCompanies';
// ASIN Sales History imports
import { ASINSalesHistoryProvider } from './context/ASINSalesHistoryContext';
import ASINSalesHistoryLayout from './components/asin-sales-history/ASINSalesHistoryLayout';
// import ASINSalesHistoryDashboard from './pages/asin-sales-history/Dashboard';
// Days of Cover imports
import DaysOfCoverDashboard from './components/days-of-cover/DaysOfCoverDashboard';
// Smart Writer imports
import SmartWriterDashboard from './components/smart-writer/SmartWriterDashboard';
import SubmitAppPage from './pages/submit-app/SubmitAppPage';

function App() {
  
  return (
    <>
      <OptimizationProvider>
        <BrowserRouter>
          <AuthProvider>
            <DarkModeProvider>
              <CookieConsentProvider>
                <NotificationsProvider>
                    <TooltipProvider>
                    <CookieConsent />
                    <div className="min-h-screen">
                      <Routes>
                        {/* Public routes */}
                        <Route path="/" element={<Login />} />
                        <Route path="/login" element={<Navigate to="/" replace />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/amazonlink" element={<AmazonLink />} />

                        {/* Protected routes */}
                        <Route path="/dashboard" element={
                          <ProtectedRoute>
                            <AppHub />
                          </ProtectedRoute>
                        } />

                        {/* Settings route */}
                        <Route path="/settings" element={
                          <ProtectedRoute>
                            <Settings />
                          </ProtectedRoute>
                        } />

                        {/* LMS routes */}
                        <Route path="/lms" element={
                          <ProtectedRoute appKey="ListingManagementSystem">
                            <Layout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<Dashboard />} />
                          <Route path="products" element={<ProductsPage />} />
                          <Route path="products/:productId" element={<ProductsPage />} />
                          <Route path="prompts" element={<PromptsPage />} />
                          <Route path="stores" element={<StoresPage />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Idea Machine routes */}
                        <Route path="/idea-machine" element={
                          <ProtectedRoute>
                            <IdeaMachineLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<IdeaMachineDashboard />} />
                          <Route path="launchpad" element={<IdeaLaunchpad />} />
                          <Route path="galaxy" element={<IdeaGalaxyPage />} />
                          <Route path="feed" element={<IdeaFeedPage />} />
                          <Route path="ideas" element={<YourIdeas />} />
                          <Route path="settings" element={<IdeaMachineSettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Good Things routes */}
                        <Route path="/good-things" element={
                          <ProtectedRoute appKey="GoodThingTracker">
                            <GoodThingsLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<GoodThingsDashboard />} />
                          <Route path="feed" element={<GoodThingsFeed />} />
                          <Route path="digest" element={<GoodThingsWeeklyDigest />} />
                          <Route path="favorites" element={<Favorites />} />
                          <Route path="network" element={<GoodThingsNetwork />} />
                          <Route path="settings" element={<GoodThingsSettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* SOP Central routes */}
                        <Route path="/sop" element={
                          <ProtectedRoute appKey="SOPCentral">
                            <AppSettingsProvider>
                              <CategoryProvider>
                                <SOPLayout />
                              </CategoryProvider>
                            </AppSettingsProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<SOPDashboard />} />
                          <Route path="sophie" element={<SophiePage />} />
                          <Route path="favorites" element={<SOPFavorites />} />
                          <Route path="settings" element={<SOPSettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Ideogram PromptStorm Routes */}
                        <Route path="/ideogram" element={
                          <ProtectedRoute appKey="IdeogramPromptStorm">
                            <IdeogramLayout />
                          </ProtectedRoute>
                        }>
                          <Route path="gallery" element={<Gallery />} />
                          <Route path="prompts" element={<Prompts />} />
                          <Route index element={<Navigate to="gallery" replace />} />
                        </Route>

                        {/* PLMS routes */}
                        <Route path="/plms" element={
                          <ProtectedRoute appKey="PLMS">
                            <PLMSApp />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<PLMSDashboard />} />
                          <Route path="all-items" element={<AllItems />} />
                          <Route path="master-lists" element={<MasterLists />} />
                          <Route path="settings" element={<Settings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* PMT2 routes */}
                        <Route path="/pmt3" element={
                          <ProtectedRoute appKey="PMT2">
                            <PMT3SelectionProvider>
                              <PMT2Layout />
                            </PMT3SelectionProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<PMT2Page />} />
                          <Route path="settings" element={<PMT2Settings />} />
                          <Route path="manage-companies" element={<PMT3ManageCompanies />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* AI DevQuest Routes */}
                        <Route path="/ai-devquest" element={
                          <ProtectedRoute appKey="AIDevQuest">
                            <AIDevQuestLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<AIDevQuestDashboard />} />
                          <Route path="settings" element={<AIDevQuestSettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Glossary Routes */}
                        <Route path="/glossary" element={
                          <ProtectedRoute appKey="Glossary">
                            <CategoryProvider>
                              <GlossaryLayout />
                            </CategoryProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<GlossaryDashboard />} />
                          <Route path="favorites" element={<GlossaryFavorites />} />
                          <Route path="settings" element={<GlossarySettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Day Away Board Routes */}
                        <Route path="/day-away" element={
                          <ProtectedRoute appKey="DayAwayBoard">
                            <TimeOffDialogProvider>
                              <DayAwayLayout />
                            </TimeOffDialogProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<DayAwayDashboard />} />
                          <Route path="calendar" element={<DayAwayCalendar />} />
                          <Route path="ledger" element={<DayAwayLedger />} />
                          <Route path="dashboard-sheet" element={<DayAwayDashboardSheet />} />
                          <Route path="my-team" element={<MyTeam />} />
                          <Route path="settings" element={<DayAwaySettings />} />
                          <Route path="admin" element={
                            <AdminProtectedRoute>
                              <AdminPanel />
                            </AdminProtectedRoute>
                          } />
                        </Route>

                        {/* Employee Directory Routes */}
                        <Route path="/employee-directory" element={
                          <ProtectedRoute appKey="EmployeeDirectory">
                            <EmployeeDirectoryLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<EmployeeDirectoryDashboard />} />
                          <Route path="directory" element={<EmployeeDirectoryDirectory />} />
                          <Route path="globe" element={<EmployeeDirectoryGlobe />} />
                        </Route>

                        {/* Product Manager Routes */}
                        <Route path="/product-manager" element={
                          <ProtectedRoute appKey="ProductManager">
                            <ProductManagerLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<ProductManagerDashboard />} />
                          <Route path="projects" element={<ProductManagerProjects />} />
                          <Route path="projects/:projectId" element={<ProductManagerProjectDetail />} />
                          <Route path="tasks" element={<ProductManagerTasks />} />
                          <Route path="tasks/:taskId" element={<ProductManagerTaskDetail />} />
                          <Route path="settings" element={<ProductManagerSettings />} />
                        </Route>

                        {/* PPC Farm Mail Tracker Routes */}
                        <Route path="/ppc-farm" element={
                          <ProtectedRoute appKey="PPCFarmMailTracker">
                            <PpcFarmLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<Navigate to="dashboard" replace />} />
                          <Route path="dashboard" element={<PpcFarmDashboardPage />} />
                          <Route path="keyword-discovery" element={<PpcFarmKeywordDiscoveryPage />} />
                          <Route path="target-ledger" element={<PpcFarmTargetLedgerPage />} />
                          <Route path="cohort-ledger" element={<PpcFarmCohortLedgerPage />} />
                          <Route path="mailing-ledger" element={<PpcFarmMailingLedgerPage />} />
                          <Route path="cohort-builder" element={<PpcFarmCohortBuilderPage />} />
                          <Route path="potential-problems" element={<PpcFarmPotentialProblemsPage />} />
                          <Route path="review-session/:cohortId" element={<PpcFarmReviewSessionPage />} />
                          <Route path="mailing-cost-dashboard" element={<PpcFarmMailingCostDashboard />} />
                          <Route path="settings" element={<PpcFarmSettings />} />
                        </Route>

                        {/* Amazon Index Checker Routes */}
                        <Route path="/amazon-index-checker" element={
                          <ProtectedRoute appKey="AmazonIndexChecker">
                            <PMT3SelectionProvider>
                              <AmazonIndexLayout />
                            </PMT3SelectionProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<AmazonIndexChecker />} />
                        </Route>

                        {/* SB Search Term Report Routes */}
                        <Route path="/sb-search-term-report" element={
                          <ProtectedRoute appKey="SBSearchTermReport">
                            <SBSearchTermReportLayout />
                          </ProtectedRoute>
                        }>
                          <Route index element={<SBSearchTermReportIndex />} />
                          <Route path="dashboard" element={<SBSearchTermReportDashboard />} />
                          <Route path="profile-selection" element={<SBSearchTermReportProfileSelection />} />
                        </Route>

                        {/* Farming Results Routes */}
                        <Route path="/farming-results" element={
                          <ProtectedRoute appKey="FarmingResults">
                            <FarmingResultsSelectionProvider>
                              <FarmingResults />
                            </FarmingResultsSelectionProvider>
                          </ProtectedRoute>
                        } />

                        {/* Primary Ledger Routes */}
                        <Route path="/primary-ledger" element={
                          <ProtectedRoute appKey="PrimaryLedger">
                            <PrimaryLedgerProvider>
                              <PrimaryLedgerLayout />
                            </PrimaryLedgerProvider>
                          </ProtectedRoute>
                        }>
                          <Route index element={<PrimaryLedgerDashboard />} />
                          <Route path="snapshots" element={<PrimaryLedgerSnapshots />} />
                          <Route path="manage-companies" element={<PrimaryLedgerManageCompanies />} />
                        </Route>

                        {/* Sales & Profit History Routes */}
                        <Route path="/sales-and-profit-history" element={
                          <ProtectedRoute appKey="ASINSalesHistory">
                            <ASINSalesHistoryProvider>
                              <ASINSalesHistoryLayout />
                            </ASINSalesHistoryProvider>
                          </ProtectedRoute>
                        } />
                
                        {/* Days of Cover Routes */}
                        <Route path="/days-of-cover" element={
                          <ProtectedRoute appKey="DaysOfCover">
                            <DaysOfCoverDashboard />
                          </ProtectedRoute>
                        } />

                        {/* Smart Writer Routes */}
                        <Route path="/smart-writer" element={
                          <ProtectedRoute>
                            <SmartWriterDashboard />
                          </ProtectedRoute>
                        } />

                        {/* Submit App Route */}
                        <Route path="/submit-app" element={
                          <ProtectedRoute>
                            <SubmitAppPage />
                          </ProtectedRoute>
                        } />

                        {/* Admin route */}
                        <Route path="/admin" element={
                          <AdminProtectedRoute>
                            <AdminPanel />
                          </AdminProtectedRoute>
                        } />

                        {/* Apps route */}
                        <Route path="/apps" element={<AppHub />} />

                        {/* Catch-all route */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </div>
                    </TooltipProvider>
                </NotificationsProvider>
              </CookieConsentProvider>
            </DarkModeProvider>
          </AuthProvider>
        </BrowserRouter>
      </OptimizationProvider>
      <CustomToaster />
    </>
  );
}

export default App;
